/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function useCostHook(costFrom?: number, costTo?: number) {
  const from = costFrom ?? 0;
  const to = costTo ?? 0;

  const hasCosts =
    (Boolean(from) || costFrom === 0) && (Boolean(to) || costTo === 0);
  const isCostToInvalid = hasCosts && from > to;

  const isCostFromNegative = costFrom ? costFrom < 0 : false;
  const isCostToNegative = costTo ? costTo < 0 : false;
  const isCostInvalid =
    isCostToInvalid || isCostFromNegative || isCostToNegative;

  return {
    isCostToInvalid,
    isCostFromNegative,
    isCostToNegative,
    isCostInvalid,
  };
}
